<!-- Floating Toolbar (excluded from PDF export) -->
<div class="toolbar no-export" *ngIf="!isLoading && !noDataFound">
  <button class="btn-download" (click)="downloadPDF()" aria-label="Download PDF" title="Download PDF">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="7 10 12 15 17 10"/>
      <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
  </button>
  <button class="btn-whatsapp" style="display: none;" (click)="shareWhatsApp()" aria-label="Share on WhatsApp" title="Share on WhatsApp">
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.149-.15.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.05-.52-.099-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.04 21.785h-.004a9.87 9.87 0 01-4.988-1.354l-.358-.213-3.712.975.995-3.617-.233-.375a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.94 9.884zm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.49-8.413z"/>
    </svg>
  </button>
  <button class="btn-email" style="display: none;" (click)="emailReport()" aria-label="Email Report" title="Email Report">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
    </svg>
  </button>
</div>

<!-- Status toast -->
<div class="toolbar-status no-export" [class.show]="showStatus">{{ statusMessage }}</div>

<!-- Loading State -->
<div class="loading-state" *ngIf="isLoading">
  <div class="loading-spinner"></div>
  <p>Fetching your WealthLens Report...</p>
</div>

<!-- No Investment Data Popup (centered, matches the form page style) -->
<div class="wl-modal-overlay no-export" *ngIf="!isLoading && noDataFound">
  <div class="wl-modal-card">
    <button class="wl-close-button" (click)="goToReportPage()">&times;</button>
    <div class="wl-nodata-screen">
      <div class="wl-nodata-icon">!</div>
      <h3 class="wl-modal-heading">No current investment found</h3>
      <p class="wl-modal-subheading">We couldn't find any mutual fund holdings linked to the details you entered. Please check your PAN and try again.</p>
      <button type="button" class="wl-submit-button wl-done-button" (click)="goToReportPage()">OK</button>
    </div>
  </div>
</div>

<!-- Report Content (captured for PDF) -->
<div class="report-wrapper" #reportPage *ngIf="!isLoading && !noDataFound">

  <!-- ===== PAGE 1: COVER ===== -->
  <section class="report-page cover-page">
    <div class="cover-top">
      <a href="/wealth-report">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="cover-logo">
      </a>
    </div>

    <div class="cover-body">
      <p class="cover-eyebrow">PERSONALISED PORTFOLIO ANALYSIS</p>
      <h1 class="cover-title">Your WealthLens Report</h1>
      <p class="cover-tagline">Know your portfolio, beyond returns.</p>

      <div class="cover-info-card">
        <div class="cover-info-row">
          <span>Prepared for</span>
          <strong>{{ reportUser.name || '—' }}</strong>
        </div>
        <div class="cover-info-row">
          <span>PAN</span>
          <strong>{{ reportUser.pan || '—' }}</strong>
        </div>
        <div class="cover-info-row">
          <span>Report generated</span>
          <strong>{{ generatedOn }}</strong>
        </div>
        <div class="cover-info-row">
          <span>Portfolio Value</span>
          <strong>{{ portfolioValue }}</strong>
        </div>
        <div class="cover-info-row">
          <span>Funds analysed</span>
          <strong>{{ holdings.length }} funds</strong>
        </div>
      </div>
    </div>

    <div class="cover-footer">
      <span>Bajaj Capital · Confidential, prepared for the named individual only</span>
      <span>WealthLens Report</span>
    </div>
  </section>

  <!-- ===== PAGE 2: WEALTHLENS SCORE ===== -->
  <section class="report-page body-page pdf-page-break">
    <div class="page-header">
      <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="header-logo">
      <span class="header-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
    </div>

    <p class="section-number">01 · YOUR WEALTHLENS SCORE</p>
    <h2 class="section-headline">One Number. Three Real Checks.</h2>
    <p class="section-desc">{{ reportUser.name || 'Customer' }}, your WealthLens Score isn't a single calculation — it's three independent checks on your portfolio, combined by how much each one matters.</p>

    <div class="score-block">
      <div class="score-gauge">
        <svg viewBox="0 0 140 140">
          <circle class="gauge-track" cx="70" cy="70" r="60"/>
          <circle class="gauge-fill" cx="70" cy="70" r="60"
            [attr.stroke-dasharray]="gaugeStrokeDasharray"
            [attr.stroke-dashoffset]="0"/>
        </svg>
        <div class="gauge-center">
          <span class="gauge-number">{{ scoreValue }}</span>
          <span class="gauge-outof">out of {{ scoreOutOf }}</span>
        </div>
      </div>
      <div class="score-verdict">
        <h3 class="verdict-title">{{ scoreVerdict }}</h3>
        <p class="verdict-desc">{{ scoreDescription }}</p>
      </div>
    </div>

    <table class="report-table score-table">
      <thead>
        <tr>
          <th>Check</th>
          <th class="num">Score /10</th>
          <th>Verdict</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let check of scoreChecks">
          <td>{{ check.name }}</td>
          <td class="num">{{ check.score }}</td>
          <td><span class="verdict-badge" [class]="check.badgeClass">{{ check.verdict }}</span></td>
        </tr>
        <tr class="total-row highlight-black">
          <td><strong>WealthLens Score</strong></td>
          <td class="num"><strong>{{ scoreValue }}</strong></td>
          <td><strong>{{ scoreVerdict }}</strong></td>
        </tr>
      </tbody>
    </table>

    <div class="callout callout-maroon" style="display: none;">
      <strong>Why this matters:</strong> a single score tells you <em>whether</em> to act. This breakdown tells you <em>what</em> to act on. That's the difference between "your portfolio needs work" and "your portfolio needs less overlap between three specific funds" — and it's why a conversation with an advisor is worth having, not just a number to file away.
    </div>

    <div class="page-footer">
      <span>WealthLens Report</span>
      <span>Page 2</span>
    </div>
  </section>

  <!-- ===== PAGE 3: HOLDINGS ===== -->
  <section class="report-page body-page pdf-page-break">
    <div class="page-header">
      <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="header-logo">
      <span class="header-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
    </div>

    <p class="section-source">Source: Portfolio Analysis, data as of {{ generatedOn }}</p>
    <p class="section-number">02 · YOUR HOLDINGS</p>
    <h2 class="section-headline">Everything Starts Here.</h2>
    <p class="section-desc">Every score in this report is built from these {{ holdings.length }} funds and how much of your money sits in each. This is the input for every calculation that follows.</p>

    <table class="report-table holdings-table holdings-desktop">
      <thead>
        <tr>
          <th>Fund</th>
          <th>Asset Class</th>
          <th class="num">Value</th>
          <th class="num">Weight</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let holding of holdings; let i = index">
          <td>{{ holding.fund }}</td>
          <td>{{ holding.category }}</td>
          <td class="num">{{ holding.value }}</td>
          <td class="num">{{ holding.percent }}</td>
        </tr>
        <tr class="total-row highlight-black">
          <td><strong>Total</strong></td>
          <td></td>
          <td class="num"><strong>{{ portfolioValue }}</strong></td>
          <td class="num"><strong>100%</strong></td>
        </tr>
      </tbody>
    </table>

    <!-- Mobile card view for holdings -->
    <div class="holdings-mobile">
      <div class="holding-card" *ngFor="let holding of holdings">
        <div class="holding-card-row">
          <span class="holding-card-label">FUND</span>
          <span class="holding-card-value">{{ holding.fund }}</span>
        </div>
        <div class="holding-card-row">
          <span class="holding-card-label">Asset Class</span>
          <span class="holding-card-value">{{ holding.category }}</span>
        </div>
        <div class="holding-card-row">
          <span class="holding-card-label">VALUE</span>
          <span class="holding-card-value">{{ holding.value }}</span>
        </div>
        <div class="holding-card-row">
          <span class="holding-card-label">% OF PORTFOLIO</span>
          <span class="holding-card-value">{{ holding.percent }}</span>
        </div>
      </div>
      <div class="holding-card holding-card-total">
        <div class="holding-card-row">
          <span class="holding-card-label">TOTAL VALUE</span>
          <span class="holding-card-value"><strong>{{ portfolioValue }}</strong></span>
        </div>
        <div class="holding-card-row">
          <span class="holding-card-label">TOTAL WEIGHT</span>
          <span class="holding-card-value"><strong>100%</strong></span>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <span>WealthLens Report</span>
      <span>Page 3</span>
    </div>
  </section>

  <!-- ===== PAGE 4: ASSET ALLOCATION ===== -->
  <section class="report-page body-page pdf-page-break">
    <div class="page-header">
      <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="header-logo">
      <span class="header-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
    </div>

    <p class="section-source">Source: Value Research, data as of {{ generatedOn }}</p>
    <p class="section-number">03 · ASSET ALLOCATION</p>
    <h2 class="section-headline">What Your Funds Actually Hold.</h2>
    <p class="section-desc">Each fund's own Equity/Debt/Gold/Other split is weighted by how much of your money is in that fund, then added up.</p>

    <div class="allocation-list">
      <div class="allocation-row" *ngFor="let allocation of allocations">
        <span class="alloc-label">{{ allocation.label }}</span>
        <div class="alloc-bar-track">
          <div class="alloc-bar-fill bar-warm" [style.width.%]="allocation.value < 1 ? 1 : allocation.value"></div>
        </div>
        <span class="alloc-value">{{ allocation.text }}</span>
      </div>
    </div>

    <div class="callout callout-maroon" *ngIf="allocationInsight">
      <strong>In plain terms:</strong> {{ allocationInsight }}
    </div>

    <div class="page-footer">
      <span>WealthLens Report</span>
      <span>Page 4</span>
    </div>
  </section>

  <!-- ===== PAGE 5: DIVERSIFICATION ===== -->
  <section class="report-page body-page pdf-page-break">
    <div class="page-header">
      <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="header-logo">
      <span class="header-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
    </div>

    <p class="section-source">Source: Fund-vs-fund overlap analysis, data as of {{ generatedOn }}</p>
    <p class="section-number">04 · DIVERSIFICATION</p>
    <h2 class="section-headline">How Different Are Your Funds, Really?</h2>
    <p class="section-desc">Every pair of funds is checked for stock overlap, and each fund's result is weighted by its size in your portfolio, then added up into one score.</p>

    <!-- Scale bar -->
    <div class="scale-bar-container">
      <div class="scale-bar">
        <div class="scale-segment segment-red" style="flex:6.5"></div>
        <div class="scale-segment segment-yellow" style="flex:1.5"></div>
        <div class="scale-segment segment-green" style="flex:2"></div>
        <div class="scale-pointer" [style.left.%]="diversificationScore * 10">
          <span class="scale-pointer-value">{{ diversificationScore }}/10</span>
        </div>
      </div>
      <div class="scale-labels">
        <span>0</span>
        <span>10</span>
      </div>
      <div class="scale-legend">
        <span class="legend-dot dot-red"></span> Needs Improvement
        <span class="legend-dot dot-yellow"></span> Good, Scope for Improvement
        <span class="legend-dot dot-green"></span> Excellent
      </div>
    </div>

    <div class="callout callout-maroon">
      <strong>Your result:</strong> {{ diversificationResult }}
    </div>

    <h3 class="sub-heading">Portfolio-wide breakdown</h3>
    <table class="report-table">
      <thead>
        <tr>
          <th>Overlap Level</th>
          <th class="num">% of Portfolio</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of overlapBreakdown">
          <td><span class="verdict-badge" [class]="row.badgeClass">{{ row.level }}</span></td>
          <td class="num">{{ row.percent }}</td>
        </tr>
      </tbody>
    </table>

    <div class="callout callout-maroon" *ngIf="diversificationCause">
      <strong>Which funds are causing this:</strong> {{ diversificationCause }}
    </div>

    <div class="page-footer">
      <span>WealthLens Report</span>
      <span>Page 5</span>
    </div>
  </section>

  <!-- ===== PAGE 6: RISK ALIGNMENT + QUALITY ===== -->
  <section class="report-page body-page pdf-page-break">
    <div class="page-header">
      <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="header-logo">
      <span class="header-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
    </div>

    <p class="section-source">Source: Your risk profile questionnaire &amp; portfolio analysis</p>
    <p class="section-number">05 · RISK ALIGNMENT</p>
    <h2 class="section-headline">Does Your Portfolio Match How You Answered?</h2>
    <p class="section-desc">You told us your risk appetite ({{ selectedRiskProfile }}). We check that against the real equity % sitting in your portfolio — not just the label on your funds.</p>

    <!-- Risk scale bar -->
    <div class="scale-bar-container">
      <div class="scale-bar">
        <div class="scale-segment segment-red" style="flex:6.5"></div>
        <div class="scale-segment segment-yellow" style="flex:1.5"></div>
        <div class="scale-segment segment-green" style="flex:2"></div>
        <div class="scale-pointer" [style.left.%]="riskAlignmentScore * 10">
          <span class="scale-pointer-value">{{ riskAlignmentScore }}/10</span>
        </div>
      </div>
      <div class="scale-labels">
        <span>0</span>
        <span>10</span>
      </div>
      <div class="scale-legend">
        <span class="legend-dot dot-red"></span> Needs Improvement
        <span class="legend-dot dot-yellow"></span> Good, Scope for Improvement
        <span class="legend-dot dot-green"></span>  Excellent
      </div>
    </div>

    <div class="callout callout-maroon">
      <strong>Your result:</strong> {{ riskAlignmentResult }}
    </div>

    <div class="section-divider"></div>

    <p class="section-source">Source: Value Research, data as of {{ generatedOn }}</p>
    <p class="section-number">06 · QUALITY OF FUNDS</p>
    <h2 class="section-headline">Are These Good Funds, Individually?</h2>
    <p class="section-desc">Each fund carries its own 1–5 quality score from Value Research. We take the weighted average across your holdings, then scale it to match the other checks out of 10.</p>

    <!-- Quality scale bar -->
    <div class="scale-bar-container">
      <div class="scale-bar">
        <div class="scale-segment segment-red" style="flex:6.5"></div>
        <div class="scale-segment segment-yellow" style="flex:1.5"></div>
        <div class="scale-segment segment-green" style="flex:2"></div>
        <div class="scale-pointer" [style.left.%]="qualityScore * 10">
          <span class="scale-pointer-value">{{ qualityScore }}/10</span>
        </div>
      </div>
      <div class="scale-labels">
        <span>0</span>
        <span>10</span>
      </div>
      <div class="scale-legend">
        <span class="legend-dot dot-red"></span> Needs Improvement
        <span class="legend-dot dot-yellow"></span> Good, Scope for Improvement
        <span class="legend-dot dot-green"></span> Excellent
      </div>
    </div>

    <div class="callout callout-maroon">
      <strong>Your result:</strong> {{ qualityResult }}
    </div>

    <div class="page-footer">
      <span>WealthLens Report</span>
      <span>Page 6</span>
    </div>
  </section>

  <!-- ===== PAGE 7: WHAT TO DO NEXT ===== -->
  <section class="report-page body-page pdf-page-break">
    <div class="page-header">
      <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="header-logo">
      <span class="header-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
    </div>

    <p class="section-number">07 · WHAT TO DO NEXT</p>
    <!-- <h2 class="section-headline">One Fix Away From a Better Score.</h2> -->
    <h2 class="section-headline">Turn Your Insights Into Action.</h2>
    <div class="callout callout-maroon">
      <strong>The honest summary, {{ reportUser.name || 'Customer' }}:</strong> {{ nextStepSummary }}
    </div>

    <h3 class="sub-heading" style="display: none;">Why this is worth a conversation, not just a read</h3>
    <p class="section-desc" style="display: none;">A report can tell you <em>that</em> three funds overlap. It can't tell you <em>which one to reduce</em> without knowing your goals, your tax position, and what each fund is actually for in your plan. That's the part a Bajaj Capital advisor does — turning "your diversification score is 6/10" into an actual decision.</p>

    <div class="cta-card cta-card-black">
      <!-- <p><strong class="cta-highlight">Talk to your Relationship Manager</strong> — free, no obligation — to turn this report into a plan for exactly which funds to trim, hold or add.</p> -->
       <p>Talk to Bajaj Capital Relationship Manager to understand your portfolio insights in greater detail and discuss the next steps that may be right for you.</p>
      <div class="cta-divider"></div>
      <p class="cta-rm-row" *ngIf="showRmDetails">
        <span class="cta-rm-name">{{ rmName }}</span>
        <span class="cta-rm-sep" *ngIf="rmPhone"> · </span>
        <span *ngIf="rmPhone">{{ rmPhone }}</span>
        <span class="cta-rm-sep" *ngIf="rmEmail"> · </span>
        <span *ngIf="rmEmail">{{ rmEmail }}</span>
      </p>
      <p class="cta-contact">Or call our customer care desk: 1800-103-7373 · www.bajajcapital.com</p>
    </div>

    <div class="disclaimer-block">
      <p><strong>Disclaimer:</strong> Mutual fund investments are subject to market risks; please read all scheme-related documents carefully before investing. Past performance is not indicative of future returns. This report is generated based on portfolio and fund data as of {{ generatedOn }} and is intended solely for the use of {{ reportUser.name || 'the named individual' }}. Fund quality scores are sourced from Value Research and reflect their assessment as of the date noted; Bajaj Capital does not independently verify third-party ratings. This report is for informational purposes only and does not constitute investment advice — please consult your Relationship Manager or a SEBI-registered investment adviser before making any investment decision. Bajaj Capital Ltd., AMFI-registered Mutual Fund Distributor, ARN-0010.</p>
    </div>

    <div class="page-footer">
      <span>WealthLens Report</span>
      <span>Page 7</span>
    </div>
  </section>

</div>

<!-- ============================================================
     PDF EXPORT TEMPLATE
     Mounted only while exporting, parked off-screen by .pdf-stage.
     Every .pdf-page is authored at 1100 x 1550 px, which maps 1:1
     onto a single A4 portrait sheet.
     Do not hide this with display/visibility/opacity, and do not
     make .pdf-root absolutely positioned — either produces a blank
     PDF. See the .pdf-stage rules in the stylesheet.
     ============================================================ -->
<div class="pdf-stage no-export" *ngIf="isExporting" aria-hidden="true">
  <div class="pdf-root" id="pdfRoot">

    <!-- ---------- PDF PAGE 1: COVER ---------- -->
    <section class="pdf-page pdf-cover">
      <div class="cover-top">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="cover-logo">
      </div>

      <div class="cover-body">
        <p class="cover-eyebrow">PERSONALISED PORTFOLIO ANALYSIS</p>
        <h1 class="cover-title">Your WealthLens Report</h1>
        <p class="cover-tagline">Know your portfolio, beyond returns.</p>

        <div class="cover-info-card">
          <div class="cover-info-row">
            <span>Prepared for</span>
            <strong>{{ reportUser.name || '—' }}</strong>
          </div>
          <div class="cover-info-row">
            <span>PAN</span>
            <strong>{{ reportUser.pan || '—' }}</strong>
          </div>
          <div class="cover-info-row">
            <span>Report generated</span>
            <strong>{{ generatedOn }}</strong>
          </div>
          <div class="cover-info-row">
            <span>Portfolio Value</span>
            <strong>{{ portfolioValue }}</strong>
          </div>
          <div class="cover-info-row">
            <span>Funds analysed</span>
            <strong>{{ holdings.length }} funds</strong>
          </div>
        </div>
      </div>

      <div class="cover-footer">
        <span>Bajaj Capital · Confidential, prepared for the named individual only</span>
        <span>WealthLens Report</span>
      </div>
    </section>

    <!-- ---------- PDF PAGE 2: WEALTHLENS SCORE ---------- -->
    <section class="pdf-page">
      <div class="pdf-header">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="pdf-logo">
        <span class="pdf-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
      </div>

      <div class="pdf-body">
        <p class="section-number">01 · YOUR WEALTHLENS SCORE</p>
        <h2 class="section-headline">One Number. Three Real Checks.</h2>
        <p class="section-desc">{{ reportUser.name || 'Customer' }}, your WealthLens Score isn't a single calculation — it's three independent checks on your portfolio, combined by how much each one matters.</p>

        <div class="score-block">
          <div class="score-gauge">
            <img [src]="pdfGaugeDataUri" alt="WealthLens Score Gauge" class="gauge-img" width="96" height="96">
            <div class="gauge-center">
              <span class="gauge-number">{{ scoreValue }}</span>
              <span class="gauge-outof">out of {{ scoreOutOf }}</span>
            </div>
          </div>
          <div class="score-verdict">
            <h3 class="verdict-title">{{ scoreVerdict }}</h3>
            <p class="verdict-desc">{{ scoreDescription }}</p>
          </div>
        </div>

        <table class="report-table score-table">
          <thead>
            <tr>
              <th>Check</th>
              <th class="num">Score /10</th>
              <th>Verdict</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let check of scoreChecks">
              <td>{{ check.name }}</td>
              <td class="num">{{ check.score }}</td>
              <td><span class="verdict-badge" [class]="check.badgeClass">{{ check.verdict }}</span></td>
            </tr>
            <tr class="total-row highlight-black">
              <td><strong>WealthLens Score</strong></td>
              <td class="num"><strong>{{ scoreValue }}</strong></td>
              <td><strong>{{ scoreVerdict }}</strong></td>
            </tr>
          </tbody>
        </table>

        <div class="callout callout-maroon" style="display: none;">
          <strong>Why this matters:</strong> a single score tells you <em>whether</em> to act. This breakdown tells you <em>what</em> to act on. That's the difference between "your portfolio needs work" and "your portfolio needs less overlap between three specific funds" — and it's why a conversation with an advisor is worth having, not just a number to file away.
        </div>
      </div>

      <div class="pdf-footer">
        <span>WealthLens Report</span>
        <span>Page 2</span>
      </div>
    </section>

    <!-- ---------- PDF PAGE 3+: HOLDINGS (flows across pages) ----------
         During the measuring pass this renders as a single sheet holding
         every row, plus BOTH the intro and continued labels, so each part
         can be measured before the rows are chunked for the real pass. -->
    <section class="pdf-page pdf-holdings-page"
             *ngFor="let pageRows of pdfHoldingsPages; let p = index; let isLastHoldingsPage = last">
      <div class="pdf-header">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="pdf-logo">
        <span class="pdf-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
      </div>

      <div class="pdf-body">
        <div class="pdf-holdings-intro" *ngIf="pdfMeasuring || p === 0">
          <p class="section-source">Source: Portfolio Analysis, data as of {{ generatedOn }}</p>
          <p class="section-number">02 · YOUR HOLDINGS</p>
          <h2 class="section-headline">Everything Starts Here.</h2>
          <p class="section-desc">Every score in this report is built from these {{ holdings.length }} funds and how much of your money sits in each. This is the input for every calculation that follows.</p>
        </div>

        <p class="section-number pdf-continued pdf-holdings-continued"
           *ngIf="pdfMeasuring || p > 0">02 · YOUR HOLDINGS (CONTINUED)</p>

        <table class="report-table holdings-table">
          <thead>
            <tr>
              <th>Fund</th>
              <th>Asset Class</th>
              <th class="num">Value</th>
              <th class="num">Weight</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pdf-holding-row" *ngFor="let holding of pageRows">
              <td>{{ holding.fund }}</td>
              <td>{{ holding.category }}</td>
              <td class="num">{{ holding.value }}</td>
              <td class="num">{{ holding.percent }}</td>
            </tr>
            <tr class="total-row highlight-black" *ngIf="isLastHoldingsPage">
              <td><strong>Total</strong></td>
              <td></td>
              <td class="num"><strong>{{ portfolioValue }}</strong></td>
              <td class="num"><strong>100%</strong></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pdf-footer">
        <span>WealthLens Report</span>
        <span>Page {{ 3 + p }}</span>
      </div>
    </section>

    <!-- ---------- PDF: ASSET ALLOCATION ---------- -->
    <section class="pdf-page">
      <div class="pdf-header">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="pdf-logo">
        <span class="pdf-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
      </div>

      <div class="pdf-body">
        <p class="section-source">Source: Value Research, data as of {{ generatedOn }}</p>
        <p class="section-number">03 · ASSET ALLOCATION</p>
        <h2 class="section-headline">What Your Funds Actually Hold.</h2>
        <p class="section-desc">Each fund's own Equity/Debt/Gold/Other split is weighted by how much of your money is in that fund, then added up.</p>

        <div class="allocation-list">
          <div class="allocation-row" *ngFor="let allocation of allocations">
            <span class="alloc-label">{{ allocation.label }}</span>
            <div class="alloc-bar-track">
              <div class="alloc-bar-fill bar-warm" [style.width.%]="allocation.value < 1 ? 1 : allocation.value"></div>
            </div>
            <span class="alloc-value">{{ allocation.text }}</span>
          </div>
        </div>

        <div class="callout callout-maroon" *ngIf="allocationInsight">
          <strong>In plain terms:</strong> {{ allocationInsight }}
        </div>
      </div>

      <div class="pdf-footer">
        <span>WealthLens Report</span>
        <span>Page {{ pdfAllocationPage }}</span>
      </div>
    </section>

    <!-- ---------- PDF: DIVERSIFICATION ---------- -->
    <section class="pdf-page">
      <div class="pdf-header">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="pdf-logo">
        <span class="pdf-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
      </div>

      <div class="pdf-body">
        <p class="section-source">Source: Fund-vs-fund overlap analysis, data as of {{ generatedOn }}</p>
        <p class="section-number">04 · DIVERSIFICATION</p>
        <h2 class="section-headline">How Different Are Your Funds, Really?</h2>
        <p class="section-desc">Every pair of funds is checked for stock overlap, and each fund's result is weighted by its size in your portfolio, then added up into one score.</p>

        <div class="scale-bar-container">
          <div class="scale-bar">
            <div class="scale-segment segment-red" style="flex:6.5"></div>
            <div class="scale-segment segment-yellow" style="flex:1.5"></div>
            <div class="scale-segment segment-green" style="flex:2"></div>
            <div class="scale-pointer" [style.left.%]="clampPointerLeft(diversificationScore)">
              <span class="scale-pointer-value">{{ diversificationScore }}/10</span>
            </div>
          </div>
          <div class="scale-labels">
            <span>0</span>
            <span>10</span>
          </div>
          <div class="scale-legend">
            <span class="legend-dot dot-red"></span> Needs Improvement
            <span class="legend-dot dot-yellow"></span> Good, Scope for Improvement
            <span class="legend-dot dot-green"></span> Excellent
          </div>
        </div>

        <div class="callout callout-maroon">
          <strong>Your result:</strong> {{ diversificationResult }}
        </div>

        <h3 class="sub-heading">Portfolio-wide breakdown</h3>
        <table class="report-table">
          <thead>
            <tr>
              <th>Overlap Level</th>
              <th class="num">% of Portfolio</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of overlapBreakdown">
              <td><span class="verdict-badge" [class]="row.badgeClass">{{ row.level }}</span></td>
              <td class="num">{{ row.percent }}</td>
            </tr>
          </tbody>
        </table>

        <div class="callout callout-maroon" *ngIf="diversificationCause">
          <strong>Which funds are causing this:</strong> {{ diversificationCause }}
        </div>
      </div>

      <div class="pdf-footer">
        <span>WealthLens Report</span>
        <span>Page {{ pdfDiversificationPage }}</span>
      </div>
    </section>

    <!-- ---------- PDF: RISK ALIGNMENT ---------- -->
    <section class="pdf-page">
      <div class="pdf-header">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="pdf-logo">
        <span class="pdf-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
      </div>

      <div class="pdf-body">
        <p class="section-source">Source: Your risk profile questionnaire &amp; portfolio analysis</p>
        <p class="section-number">05 · RISK ALIGNMENT</p>
        <h2 class="section-headline">Does Your Portfolio Match How You Answered?</h2>
        <p class="section-desc">You told us your risk appetite ({{ selectedRiskProfile }}). We check that against the real equity % sitting in your portfolio — not just the label on your funds.</p>

        <div class="scale-bar-container">
          <div class="scale-bar">
            <div class="scale-segment segment-red" style="flex:6.5"></div>
            <div class="scale-segment segment-yellow" style="flex:1.5"></div>
            <div class="scale-segment segment-green" style="flex:2"></div>
            <div class="scale-pointer" [style.left.%]="clampPointerLeft(riskAlignmentScore)">
              <span class="scale-pointer-value">{{ riskAlignmentScore }}/10</span>
            </div>
          </div>
          <div class="scale-labels">
            <span>0</span>
            <span>10</span>
          </div>
          <div class="scale-legend">
            <span class="legend-dot dot-red"></span> Needs Improvement
            <span class="legend-dot dot-yellow"></span> Good, Scope for Improvement
            <span class="legend-dot dot-green"></span>  Excellent
          </div>
        </div>

        <div class="callout callout-maroon">
          <strong>Your result:</strong> {{ riskAlignmentResult }}
        </div>
      </div>

      <div class="pdf-footer">
        <span>WealthLens Report</span>
        <span>Page {{ pdfRiskPage }}</span>
      </div>
    </section>

    <!-- ---------- PDF: QUALITY OF FUNDS ---------- -->
    <section class="pdf-page">
      <div class="pdf-header">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="pdf-logo">
        <span class="pdf-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
      </div>

      <div class="pdf-body">
        <p class="section-source">Source: Value Research, data as of {{ generatedOn }}</p>
        <p class="section-number">06 · QUALITY OF FUNDS</p>
        <h2 class="section-headline">Are These Good Funds, Individually?</h2>
        <p class="section-desc">Each fund carries its own 1–5 quality score from Value Research. We take the weighted average across your holdings, then scale it to match the other checks out of 10.</p>

        <div class="scale-bar-container">
          <div class="scale-bar">
            <div class="scale-segment segment-red" style="flex:6.5"></div>
            <div class="scale-segment segment-yellow" style="flex:1.5"></div>
            <div class="scale-segment segment-green" style="flex:2"></div>
            <div class="scale-pointer" [style.left.%]="clampPointerLeft(qualityScore)">
              <span class="scale-pointer-value">{{ qualityScore }}/10</span>
            </div>
          </div>
          <div class="scale-labels">
            <span>0</span>
            <span>10</span>
          </div>
          <div class="scale-legend">
            <span class="legend-dot dot-red"></span> Needs Improvement
            <span class="legend-dot dot-yellow"></span> Good, Scope for Improvement
            <span class="legend-dot dot-green"></span> Excellent
          </div>
        </div>

        <div class="callout callout-maroon">
          <strong>Your result:</strong> {{ qualityResult }}
        </div>
      </div>

      <div class="pdf-footer">
        <span>WealthLens Report</span>
        <span>Page {{ pdfQualityPage }}</span>
      </div>
    </section>

    <!-- ---------- PDF: WHAT TO DO NEXT ---------- -->
    <section class="pdf-page">
      <div class="pdf-header">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital" class="pdf-logo">
        <span class="pdf-crumb">BAJAJ CAPITAL · WEALTHLENS REPORT · {{ (reportUser.name || '') | uppercase }}</span>
      </div>

      <div class="pdf-body">
        <p class="section-number">07 · WHAT TO DO NEXT</p>
        <!-- <h2 class="section-headline">One Fix Away From a Better Score.</h2> -->
        <h2 class="section-headline">Turn Your Insights Into Action.</h2>

        <div class="callout callout-maroon">
          <strong>The honest summary, {{ reportUser.name || 'Customer' }}:</strong> {{ nextStepSummary }}
        </div>

        <h3 class="sub-heading" style="display: none;">Why this is worth a conversation, not just a read</h3>
        <p class="section-desc" style="display: none;">A report can tell you <em>that</em> three funds overlap. It can't tell you <em>which one to reduce</em> without knowing your goals, your tax position, and what each fund is actually for in your plan. That's the part a Bajaj Capital advisor does — turning "your diversification score is 6/10" into an actual decision.</p>

        <div class="cta-card cta-card-black">
          <!-- <p><strong class="cta-highlight">Talk to your Relationship Manager</strong> — free, no obligation — to turn this report into a plan for exactly which funds to trim, hold or add.</p> -->
          <p>Talk to Bajaj Capital Relationship Manager to understand your portfolio insights in greater detail and discuss the next steps that may be right for you.</p>
          <div class="cta-divider"></div>
          <p class="cta-rm-row" *ngIf="showRmDetails">
            <span class="cta-rm-name">{{ rmName }}</span>
            <span class="cta-rm-sep" *ngIf="rmPhone"> · </span>
            <span *ngIf="rmPhone">{{ rmPhone }}</span>
            <span class="cta-rm-sep" *ngIf="rmEmail"> · </span>
            <span *ngIf="rmEmail">{{ rmEmail }}</span>
          </p>
          <p class="cta-contact">Or call our customer care desk: 1800-103-7373 · www.bajajcapital.com</p>
        </div>

        <div class="disclaimer-block">
          <p><strong>Disclaimer:</strong> Mutual fund investments are subject to market risks; please read all scheme-related documents carefully before investing. Past performance is not indicative of future returns. This report is generated based on portfolio and fund data as of {{ generatedOn }} and is intended solely for the use of {{ reportUser.name || 'the named individual' }}. Fund quality scores are sourced from Value Research and reflect their assessment as of the date noted; Bajaj Capital does not independently verify third-party ratings. This report is for informational purposes only and does not constitute investment advice — please consult your Relationship Manager or a SEBI-registered investment adviser before making any investment decision. Bajaj Capital Ltd., AMFI-registered Mutual Fund Distributor, ARN-0010.</p>
        </div>
      </div>

      <div class="pdf-footer">
        <span>WealthLens Report</span>
        <span>Page {{ pdfNextStepsPage }}</span>
      </div>
    </section>

  </div>
</div>

<!-- Progress overlay shown while the off-screen PDF stage is rasterised -->
<div class="pdf-export-overlay no-export" *ngIf="isExporting">
  <div class="loading-spinner"></div>
  <p>Generating your PDF…</p>
</div>
